// Resizes only the Room's project panel. LiveView retains ownership of all content.
export function splitLimits(width) {
  return {min: 240, max: Math.max(240, width - 360 - 12)}
}
export function clampPanelWidth(value, width) {
  const {min, max} = splitLimits(width)
  return Math.round(Math.min(max, Math.max(min, value)))
}
export default {
  mounted() {
    this.root = this.el.parentElement
    this.minimum = Number(this.el.dataset.minWidth) || 240
    this.reserved = Number(this.el.dataset.reservedWidth) || 360
    this.defaultWidth = Number(this.el.dataset.defaultWidth) || 440
    this.preference = this.defaultWidth
    this.clamp = (value, width) => Math.round(Math.min(Math.max(this.minimum, width - this.reserved - 12), Math.max(this.minimum, value)))
    try { const saved = Number(localStorage.getItem(this.el.dataset.storageKey)); if (saved >= this.minimum) this.preference = saved } catch (_) {}
    this.sync = () => {
      if (!this.el.getClientRects().length) return
      const style = getComputedStyle(this.root)
      const width = this.root.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)
      const value = this.clamp(this.preference, width)
      this.root.style.setProperty('--room-project-panel-width', `${value}px`)
      this.el.setAttribute('aria-valuemin', String(this.minimum))
      this.el.setAttribute('aria-valuemax', String(Math.max(this.minimum, width - this.reserved - 12)))
      this.el.setAttribute('aria-valuenow', String(value))
    }
    this.save = () => { try { localStorage.setItem(this.el.dataset.storageKey, String(this.preference)) } catch (_) {} }
    this.finish = (cancel = false) => {
      if (!this.drag) return
      if (cancel) this.preference = this.drag.preference
      const id = this.drag.id
      this.drag = null
      try { this.el.releasePointerCapture?.(id) } catch (_) {}
      this.root.removeAttribute('data-resizing')
      this.frames?.forEach(([frame, value]) => {frame.style.pointerEvents = value})
      this.frames = []
      this.sync()
      if (!cancel) this.save()
    }
    this.down = event => {
      if (event.button !== 0) return
      event.preventDefault()
      this.el.focus({preventScroll:true})
      this.drag = {id:event.pointerId, x:event.clientX, width:Number(this.el.getAttribute('aria-valuenow')), preference:this.preference}
      this.el.setPointerCapture(event.pointerId)
      this.root.dataset.resizing = 'true'
      this.frames = Array.from(this.root.querySelectorAll('iframe')).map(frame => {const old = frame.style.pointerEvents; frame.style.pointerEvents = 'none'; return [frame, old]})
    }
    this.move = event => {
      if (!this.drag || event.pointerId !== this.drag.id) return
      this.preference = this.clamp(this.drag.width + this.drag.x - event.clientX, Number(this.el.getAttribute('aria-valuemax')) + this.reserved + 12)
      this.sync()
    }
    this.up = () => this.finish()
    this.cancel = () => this.finish(true)
    this.key = event => {
      if (event.key === 'Escape' && this.drag) {event.preventDefault(); event.stopPropagation(); this.finish(true); return}
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return
      event.preventDefault()
      const current = Number(this.el.getAttribute('aria-valuenow'))
      const max = Number(this.el.getAttribute('aria-valuemax'))
      this.preference = event.key === 'Home' ? this.minimum : event.key === 'End' ? max : Math.min(max, Math.max(this.minimum, current + (event.key === 'ArrowLeft' ? 1 : -1) * (event.shiftKey ? 48 : 24)))
      this.sync(); this.save()
    }
    this.reset = () => {this.preference = this.defaultWidth; this.sync(); this.save()}
    for (const [name, fn] of [['pointerdown',this.down],['pointermove',this.move],['pointerup',this.up],['pointercancel',this.cancel],['lostpointercapture',this.cancel],['keydown',this.key],['dblclick',this.reset]]) this.el.addEventListener(name,fn)
    this.observer = new ResizeObserver(this.sync)
    this.observer.observe(this.root)
    this.sync()
  },
  updated() { this.sync?.() },
  destroyed() {
    this.finish?.(true)
    this.observer?.disconnect()
    for (const [name, fn] of [['pointerdown',this.down],['pointermove',this.move],['pointerup',this.up],['pointercancel',this.cancel],['lostpointercapture',this.cancel],['keydown',this.key],['dblclick',this.reset]]) this.el.removeEventListener(name,fn)
    this.root.style.removeProperty('--room-project-panel-width')
  }
}
